import { patientName } from 'Data/format.js'

export function getView(person) {
  let name = patientName(person)
  return person.birth_date && name.length <= 20
}
